const translateText = async (text, from = "en", to = "pt") => {
  try {
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${from}&tl=${to}&dt=t&q=${encodeURIComponent(text)}`;
    const response = await fetch(url);
    const data = await response.json();
    return data[0].map((segment) => segment[0]).join("");
  } catch (e) {
    console.error("Translation error:", e);
    return text;
  }
};

export default translateText;
